const es = {
  "production.production.draft": "Borrador",
  "production.production.reserved": "Reservado",
  "production.production.in_execution": "En ejecución",
  "production.production.finished": "Finalizado",
};

export default es;
